import { QuoteOrderModelType, quoteOrderStatus, QuoteOrderStatusInversed, QuoteOrderStatusKeys } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { useState, useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import { QuoteStatusPercentageData, QuoteStatusPercentageDataKeys } from '../../../../../../../baseComponents/Dashboard/Components/DSBQuoteStatusPercentage/types'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../../utils/globals/data'
import { getPercentatge, displayFormatedNumber } from '../../../../../../../utils/globals/numbers'
import { getCurrencySymbol } from '../../../../../../../utils/globals/price'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getISOCurrencyMain } from '../../../../../../../utils/reducers/getters'
import Chart from 'react-apexcharts'
import { SellOrderModelType, sellOrderStatus, sellOrderStatusInversed, SellOrderStatusKeys } from '@teinor/erp/types/company/order/sell/sellOrder'
import { DSBCustomerChartQuoteOrderStats, SellDNStatusPercentageData, SellInvoiceStatusPercentageData, SellOrderStatsHookFunction, SellOrderStatusPercentageData, SellTicketStatusPercentageData } from './types'
import { SellDeliveryNoteModelType, sellDeliveryNoteStatus, sellDeliveryNoteStatusInversed, SellDeliveryNoteStatusKeys } from '@teinor/erp/types/company/order/sell/sellDeliveryNote'
import { SellInvoiceModelType, sellInvoiceStatus, sellInvoiceStatusInversed, SellInvoiceStatusKeys } from '@teinor/erp/types/company/order/sell/sellInvoice'
import { SellTicketModelType, SellTicketStatus, sellTicketStatus } from '@teinor/erp/types/company/order/sell/sellTicket'

interface CustomerSellOrderStatsProps { }

export const CustomerQuoteOrdersStats: React.FC<CustomerSellOrderStatsProps> = () => {
    return (
        <CustomerSellOrdersStatsComponent hookSellOrderStatsFunction={useCustomerQuotesStatsLogic} />
    )
}

export const CustomerSellOrderStats: React.FC<CustomerSellOrderStatsProps> = () => {
    return (
        <CustomerSellOrdersStatsComponent hookSellOrderStatsFunction={useCustomerSellOrdersStatsLogic} />
    )
}

export const CustomerSellDeliveryNotesStats: React.FC<CustomerSellOrderStatsProps> = () => {
    return (
        <CustomerSellOrdersStatsComponent hookSellOrderStatsFunction={useCustomerSellDeliveryNotesStatsLogic} />
    )
}

export const CustomerSellInvoicesStats: React.FC<CustomerSellOrderStatsProps> = () => {
    return (
        <CustomerSellOrdersStatsComponent hookSellOrderStatsFunction={useCustomerSellInvoicesStatsLogic} />
    )
}

export const CustomerSellTicketsStats: React.FC<CustomerSellOrderStatsProps> = () => {
    return (
        <CustomerSellOrdersStatsComponent hookSellOrderStatsFunction={useCustomerSellTicketsStatsLogic} />
    )
}

interface CustomerSellOrderStatsProps {
    hookSellOrderStatsFunction: SellOrderStatsHookFunction
}

const CustomerSellOrdersStatsComponent: React.FC<CustomerSellOrderStatsProps> = ({ hookSellOrderStatsFunction }) => {
    const CurrencySymbol = getCurrencySymbol(getISOCurrencyMain())
    const { data, labelStatus, hollowChartSize } = hookSellOrderStatsFunction()
    const labelStatusLabelList: string[] = []
    const labelStatusColorList: string[] = []
    const series: number[] = []

    if (data && labelStatus) {
        for (const key in labelStatus) {
            const singleLabelStatus = labelStatus[key]
            const percentatgeValueStatusForChart = getPercentatge(singleLabelStatus.value?.length, data?.length || 0).toFixed(2)
            series.push(parseFloat(percentatgeValueStatusForChart))
            labelStatusLabelList.push(singleLabelStatus.label)
            labelStatusColorList.push(singleLabelStatus.color)
        }
    }

    return (
        <div className='flex relative h-90 mt-5'>
            {data !== null && data ? <Chart options={{
                chart: {
                    id: 'customer_orders_informed_chart',
                    events: {
                        mounted: (chart) => {
                            chart.windowResizeHandler()
                        }
                    }
                },
                stroke: {
                    lineCap: 'round'
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: hollowChartSize,
                        },
                        inverseOrder: true,
                        offsetX: -75,
                        offsetY: -70,
                        dataLabels: {
                            show: false,
                        },
                    },
                },
                legend: {
                    show: true,
                    fontSize: "14px",
                    fontWeight: 500,
                    fontFamily: 'Roboto, sans-serif',
                    position: "top",
                    horizontalAlign: 'left',
                    offsetX: 90,
                    offsetY: 31,
                    markers: {
                        offsetX: -4,
                        offsetY: 1
                    },
                    formatter: (val, opts) => {
                        const series = opts.w.globals.series
                        const isConversionRate = val === labelStatus[series.length - 1].label
                        const labelText = !isConversionRate ? (labelStatus[opts.seriesIndex].value?.length + ' ' + val) : val
                        const labelValue = !isConversionRate ? displayFormatedNumber(labelStatus[opts.seriesIndex].value?.reduce((acc, value) => acc + value, 0).toFixed(2)) : series[series.length - 1].toFixed(2)

                        return `
                            <span class='apexcharts_custom_legend'>
                                <span class='apexcharts_custom_text'>${labelText}</span>
                                <span class='apexcharts_custom_text_value'>${labelValue + (!isConversionRate ? CurrencySymbol : '%')}</span>
                            </span>
                        `
                    }
                },
                tooltip: {
                    enabled: true,
                    custom: ({ series, seriesIndex, w }) => {
                        const labelValue = (seriesIndex !== (series.length - 1)) ? (labelStatus[seriesIndex].value?.length + '/' + data?.length) : (series[seriesIndex] + '%')
                        const labelText = w.globals.labels[seriesIndex]

                        return `
                            <div class='apexcharts_custom_tooltip_hover' style="background: ${w.globals.colors[seriesIndex]}">${labelText + ': ' + labelValue}</div>
                        `
                    }
                },
                labels: [...labelStatusLabelList],
                colors: [...labelStatusColorList],
            }}
                series={series}
                type='radialBar'
                width={250}
                className='flex items-center w-full'
            />
                :
                <div>
                    <TwinTrans transKey={'sueStatusNoInfo'}>No hay información de este estado</TwinTrans>
                </div>}
        </div>
    )
}

export const useCustomerQuotesStatsLogic = () => {
    const { id } = useParams()
    const {t} = useTwinTranslation()
    const [data, setData] = useState<QuoteOrderModelType[] | null>(null)
    const [orders, setOrders] = useState<QuoteStatusPercentageData>({
        accepted: [],
        denied: [],
        sent: [],
        waitingResponse: []
    })
    const hollowChartSize = '0%'

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/quote/getAllQuoteOrdersComplete', {
            where: {
                'QuoteOrder.CustomerId': id,
                'is_last': true
            }
        })

        if (result) {
            const categoryOrders: QuoteStatusPercentageData = {
                accepted: [],
                denied: [],
                sent: [],
                waitingResponse: []
            }

            for (const order of result) {
                const total = parseFloat(order?.total_total)
                let myStatusInversed = quoteOrderStatus[order?.status as QuoteOrderStatusKeys] as QuoteStatusPercentageDataKeys

                if (order?.status === QuoteOrderStatusInversed['processed']) {
                    myStatusInversed = 'accepted'
                }
                if (categoryOrders[myStatusInversed]) {
                    categoryOrders[myStatusInversed].push(total)
                }
            }

            setOrders(categoryOrders)
            setData(result)
        }
    }, [setData, id])

    useEffect(() => {
        getData()
    }, [getData])

    const labelStatus: DSBCustomerChartQuoteOrderStats[] = [
        {
            label: t('acceptedOrders', 'Aceptados'),
            color: '#43BAA5',
            value: orders?.accepted
        },
        {
            label: t('cancelled', 'Cancelados'),
            color: '#BA435D',
            value: orders?.denied
        },
        {
            label: t('pending', 'En espera'),
            color: '#DE9151',
            value: orders?.waitingResponse
        },
        {
            label: t('sent', 'Enviados'),
            color: '#865FE5',
            value: orders?.sent
        },
        {
            label: t('conversionRateShort', 'Tasa conv.'),
            color: '#C548FF',
            value: orders?.accepted
        }
    ]

    return { data, hollowChartSize, labelStatus }
}

export const useCustomerSellOrdersStatsLogic = () => {
    const { id } = useParams()
    const {t} = useTwinTranslation()
    const [data, setData] = useState<SellOrderModelType[] | null>(null)
    const [sellOrders, setSellOrders] = useState<SellOrderStatusPercentageData>({
        waitingResponse: [],
        accepted: [],
        denied: [],
    })
    const hollowChartSize = '15%'

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/sell/sellOrder/getAllSellOrdersComplete', {
            where: { 'SellOrder.CustomerId': id, is_last: true }
        })

        if (result) {
            const categoryOrders: SellOrderStatusPercentageData = {
                waitingResponse: [],
                accepted: [],
                denied: [],
            }

            for (const order of result) {
                const total = parseFloat(order?.total_total)
                let myStatusInversed = sellOrderStatus[order?.status as SellOrderStatusKeys] as keyof SellOrderStatusPercentageData

                if (order?.status === sellOrderStatusInversed['pendingUnits']) {
                    myStatusInversed = 'waitingResponse'
                }
                if (categoryOrders[myStatusInversed]) {
                    categoryOrders[myStatusInversed].push(total)
                }
            }

            setSellOrders(categoryOrders)
            setData(result)
        }
    }, [setData, id])

    useEffect(() => {
        getData()
    }, [getData])

    const labelStatus: DSBCustomerChartQuoteOrderStats[] = [
        {
            label: t('finisheds', 'Finalizados'),
            color: '#43BAA5',
            value: sellOrders?.accepted
        },
        {
            label: t('cancelled', 'Cancelados'),
            color: '#BA435D',
            value: sellOrders?.denied
        },
        {
            label: t('preparing', 'Preparando'),
            color: '#DE9151',
            value: sellOrders?.waitingResponse
        },
        {
            label: t('conversionRateShort', 'Tasa conv.'),
            color: '#C548FF',
            value: sellOrders?.accepted
        }
    ]

    return { data, labelStatus, hollowChartSize }
}

export const useCustomerSellDeliveryNotesStatsLogic = () => {
    const { id } = useParams()
    const {t} = useTwinTranslation()
    const [data, setData] = useState<SellDeliveryNoteModelType[] | null>(null)
    const [sellDeliveryNotes, setSellDeliveryNotes] = useState<SellDNStatusPercentageData>({
        waitingResponse: [],
        accepted: [],
        denied: [],
        refunded: []
    })
    const hollowChartSize = '15%'

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/sell/sellDeliveryNote/getAllSellDeliveryNotesComplete', {
            where: { 'SellDeliveryNote.CustomerId': id, is_last: true }
        })

        if (result) {
            const categoryOrders: SellDNStatusPercentageData = {
                waitingResponse: [],
                accepted: [],
                denied: [],
                refunded: []
            }

            for (const order of result) {
                const total = parseFloat(order?.total_total)
                let myStatusInversed = sellDeliveryNoteStatus[order?.status as SellDeliveryNoteStatusKeys] as keyof SellDNStatusPercentageData

                if (order?.status === sellDeliveryNoteStatusInversed['pendingUnits']) {
                    myStatusInversed = 'waitingResponse'
                } else if (order?.status === sellDeliveryNoteStatusInversed['denied']) {
                    myStatusInversed = 'refunded'
                }
                if (categoryOrders[myStatusInversed]) {
                    categoryOrders[myStatusInversed].push(total)
                }
            }

            setSellDeliveryNotes(categoryOrders)
            setData(result)
        }
    }, [setData, id])

    useEffect(() => {
        getData()
    }, [getData])

    const labelStatus: DSBCustomerChartQuoteOrderStats[] = [
        {
            label: t('finisheds', 'Finalizados'),
            color: '#43BAA5',
            value: sellDeliveryNotes?.accepted
        },
        {
            label: t('pendingInvoicedShort', 'Pte. Fact.'),
            color: '#DE9151',
            value: sellDeliveryNotes?.waitingResponse
        },
        {
            label: t('refundeds', 'Devueltos'),
            color: '#BA435D',
            value: sellDeliveryNotes?.refunded
        },
        {
            label: t('conversionRateShort', 'Tasa conv.'),
            color: '#C548FF',
            value: sellDeliveryNotes?.accepted
        }
    ]

    return { data, labelStatus, hollowChartSize }
}

export const useCustomerSellInvoicesStatsLogic = () => {
    const { id } = useParams()
    const {t} = useTwinTranslation()
    const [data, setData] = useState<SellInvoiceModelType[] | null>(null)
    const [sellInvoices, setSellInvoices] = useState<SellInvoiceStatusPercentageData>({
        waitingResponse: [],
        accepted: [],
        denied: [],
        refunded: []
    })
    const hollowChartSize = '30%'

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/sell/sellInvoice/getAllSellInvoicesComplete', {
            where: { 'SellInvoice.CustomerId': id, is_last: true }
        })

        if (result) {
            const categoryOrders: SellInvoiceStatusPercentageData = {
                waitingResponse: [],
                accepted: [],
                denied: [],
                refunded: []
            }

            for (const order of result) {
                const total = parseFloat(order?.total_total)
                let myStatusInversed = sellInvoiceStatus[order?.status as SellInvoiceStatusKeys] as keyof SellInvoiceStatusPercentageData

                if (order?.status === sellInvoiceStatusInversed['denied']) {
                    myStatusInversed = 'refunded'
                }
                if (categoryOrders[myStatusInversed]) {
                    categoryOrders[myStatusInversed].push(total)
                }
            }

            setSellInvoices(categoryOrders)
            setData(result)
        }
    }, [setData, id])

    useEffect(() => {
        getData()
    }, [getData])

    const labelStatus: DSBCustomerChartQuoteOrderStats[] = [
        {
            label: t('invoiceds', 'Facturados'),
            color: '#43BAA5',
            value: sellInvoices?.accepted
        },
        {
            label: t('refundeds2', 'Devueltas'),
            color: '#BA435D',
            value: sellInvoices?.refunded
        },
        {
            label: t('conversionRateShort', 'Tasa conv.'),
            color: '#C548FF',
            value: sellInvoices?.accepted
        }
    ]

    return { data, labelStatus, hollowChartSize }
}

export const useCustomerSellTicketsStatsLogic = () => {
    const { id } = useParams()
    const {t} = useTwinTranslation()
    const [data, setData] = useState<SellTicketModelType[] | null>(null)
    const [sellTickets, setSellTickets] = useState<SellTicketStatusPercentageData>({
        saved: [],
        accepted: [],
        refunded: [],
    })
    const hollowChartSize = '15%'

    const getData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/tpv/sellTicket/getAllSellTicketsComplete', {
            where: { 'SellTicket.CustomerId': id, 'SellTicket.is_last': true }
        })

        if (result) {
            const categoryOrders: SellTicketStatusPercentageData = {
                saved: [],
                accepted: [],
                refunded: [],
            }

            for (const order of result) {
                const myStatusInversed = sellTicketStatus[order.status as keyof SellTicketStatus]
                if (myStatusInversed === 'saved' || myStatusInversed === 'partialCharged') {
                    const mySavedTotal = parseFloat(order.total_clean_with_vat || 0)
                    categoryOrders['saved'].push(mySavedTotal)
                } else {
                    const myAcceptedTotal = parseFloat(order.total_clean_with_vat || 0)
                    const myRefundedTotal = parseFloat(order.total_refund_with_vat || 0)
                    if (myAcceptedTotal > 0) {
                        categoryOrders['accepted'].push(myAcceptedTotal)
                    }
                    if (myRefundedTotal > 0) {
                        categoryOrders['refunded'].push(myRefundedTotal)
                    }
                }
            }
            setSellTickets(categoryOrders)
            setData(result)
        }
    }, [setData, id])

    useEffect(() => {
        getData()
    }, [getData])

    const labelStatus: DSBCustomerChartQuoteOrderStats[] = [
        {
            label: t('reserved', 'Reservadas'),
            color: '#e8cf30',
            value: sellTickets?.saved
        },
        {
            label: t('effective', 'Efectivas'),
            color: '#43BAA5',
            value: sellTickets?.accepted
        },
        {
            label: t('refundedsF', 'Devueltas'),
            color: '#BA435D',
            value: sellTickets?.refunded
        },
        {
            label: t('conversionRateShort', 'Tasa conv.'),
            color: '#C548FF',
            value: sellTickets?.accepted
        }
    ]

    return { data, labelStatus, hollowChartSize }
}